export default {
  addWidgetTitle: "Voeg een widget toe"
}
